import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { color, toCurrency } from '@deerplusofficial/pos-helper';

const Container = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Name = styled.div`
  width: calc(100% / 2.5);
  text-align: right;
  color: ${color.text.title};
`;

const Value = styled.div`
  margin-left: auto;
`;

export const propTypes = {
  name: PropTypes.string,
  value: PropTypes.number
};

export default class PriceRow extends PureComponent {
  static propTypes = propTypes;

  static defaultProps = {
    name: '',
    value: 0
  };

  render() {
    const { name, value } = this.props;

    return (
      <Container>
        <Name>{name}</Name>
        <Value>{toCurrency(value)}</Value>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cart/PriceRow.js